module.exports = __webpack_public_path__ + "public/Icons/manage_vehicles.svg?0c06f9f3";